import React, { useState, useEffect } from 'react';

import BrandsData from '../Data/BrandsData';

const BrandsBanner = ({dimensions}) => {
	const [ count, setCount ] = useState(0);

	useEffect(()=>{
		let num = 0;
		let interval = setInterval(()=>{
			setCount(num);
			num+=2;
		},40);
		return() => {
			clearInterval(interval)
		}
	},[setCount]);

	function brandsDisplay() {
		let arr = [];
		let shrinkige = 0.3;
		let add = 40;
		if(dimensions.width < 800){
			shrinkige = 0.2;
			add = 30;
		}
		if(dimensions.width < 600){
			shrinkige = 0.18;
			add = 20;
		}
		for(const [key, value] of Object.entries(BrandsData)){
			let className = 'brandHolder2 flexCenter invisible absolute';
			// if(count >= numb){
				className = 'brandHolder2 flexCenter riseUpX absoluteX';
			// }
			arr.push(
				<div key={key} style={{width:value.width*shrinkige+add,height:value.height*shrinkige+add}} className='flexCenter'>
				<div className={className}>
					<img src={value.img_light} alt='BrandImage' style={{height:value.height*shrinkige}} />
				</div>
				</div>
			)
			// numb+=1;
		}
		return <div className='flexHeightCenter'>{arr}{arr}</div>
	}
	return(
		<div className='flexLeft' style={{overflow:'hidden',background:'rgb(0,0,0)'}}>
			{dimensions.width === undefined || isNaN(count%dimensions.width)
				? null
				: <div style={{marginLeft:-count%dimensions.width}}></div>
			}
			{brandsDisplay()}
		</div>
	)
}

export default BrandsBanner;